import React from 'react';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <footer className="bg-dark-900 border-t border-white/5 pt-20 pb-10">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

                    {/* Brand */}
                    <div>
                        <div className="mb-6">
                            <h3 className="text-2xl font-display font-black text-white leading-none">MD SAMSUDDIN</h3>
                            <span className="text-royal-500 font-bold tracking-[0.2em] text-sm">SHUTTERS</span>
                        </div>
                        <p className="text-gray-400 mb-6 leading-relaxed">
                            Leading manufacturer of ultra-premium rolling shutters. Delivering unparalleled quality, security, and innovation with luxury craftsmanship.
                        </p>
                        <div className="flex space-x-4">
                            {['📘', '🐦', '💼', '📷'].map((icon, i) => (
                                <a key={i} href="#" className="w-10 h-10 rounded-full bg-dark-800 flex items-center justify-center hover:bg-royal-500 hover:text-white transition-all transform hover:-translate-y-1">
                                    {icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-white font-bold uppercase tracking-wider mb-6">Quick Links</h4>
                        <ul className="space-y-4">
                            {['Home', 'Products', 'Features', 'Contact'].map(item => (
                                <li key={item}>
                                    <button
                                        onClick={() => scrollToSection(item.toLowerCase())}
                                        className="text-gray-400 hover:text-royal-500 transition-colors flex items-center group"
                                    >
                                        <span className="w-0 group-hover:w-2 h-[1px] bg-royal-500 mr-0 group-hover:mr-2 transition-all duration-300"></span>
                                        {item}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Products */}
                    <div>
                        <h4 className="text-white font-bold uppercase tracking-wider mb-6">Expertise</h4>
                        <ul className="space-y-4">
                            {[
                                'Industrial Shutters',
                                'Commercial Shutters',
                                'Residential Shutters',
                                'Fire Rated Shutters'
                            ].map(item => (
                                <li key={item}>
                                    <a href="#" className="text-gray-400 hover:text-royal-500 transition-colors">
                                        {item}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="text-white font-bold uppercase tracking-wider mb-6">Contact</h4>
                        <ul className="space-y-4 text-gray-400">
                            <li className="flex items-start">
                                <span className="mr-3 mt-1 text-royal-500">📍</span>
                                22, Pemantle Street, Kolkata – 700 016
                            </li>
                            <li className="flex items-start">
                                <span className="mr-3 mt-1 text-royal-500">📞</span>
                                <div className="flex flex-col">
                                    <span>90077 35583</span>
                                    <span>70032 52661</span>
                                    <span>8482014246</span>
                                </div>
                            </li>
                            <li className="flex items-center">
                                <span className="mr-3 text-royal-500">✉️</span>
                                mdsamsu848@gmail.com
                            </li>
                            <li className="flex items-center">
                                <span className="mr-3 text-royal-500">🕐</span>
                                Mon - Sat: 9:00 AM - 6:00 PM
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
                    <p>&copy; {currentYear} MD Samsuddin Shutters. All rights reserved.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a href="#" className="hover:text-royal-500 transition-colors">Privacy Policy</a>
                        <a href="#" className="hover:text-royal-500 transition-colors">Terms of Service</a>
                        <a href="#" className="hover:text-royal-500 transition-colors">Sitemap</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
